import { createContext } from 'react';
import type { MessageContextType } from '@/types/message';

export type { MessageContextType };

export const MessageContext = createContext<MessageContextType | null>(null);
